// material-ui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// project imports
import { useNavTheme } from 'contexts/NavThemeContext';

// Import the Synlets logo
import SynletsLogoSvg from 'assets/images/synlets-logo.svg';

// ==============================|| SYNLETS LOGO ||============================== //

export default function Logo() {
  const { mode } = useNavTheme();
  const isLightMode = mode === 'light';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        textDecoration: 'none',
      }}
    >
      {/* Logo Icon */}
      <Box
        component="img"
        src={SynletsLogoSvg}
        alt="Synlets"
        sx={{
          width: 34,
          height: 34,
          objectFit: 'contain',
        }}
      />

      {/* Logo Text */}
      <Typography
        sx={{
          fontSize: '1.25rem',
          fontWeight: 700,
          letterSpacing: '-0.01em',
          fontFamily: '"Satoshi", "Inter", -apple-system, BlinkMacSystemFont, sans-serif',
          color: isLightMode ? '#1e1e3f' : '#fafafa',
          textDecoration: 'none',
        }}
      >
        Synlets
      </Typography>
    </Box>
  );
}
